import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { useCountUp } from './useCountUp';

interface ItemType {
    img: [string, string];
    name: string;
    text: string;
}
const D: React.FC = () => {
    const { t } = useLang('d3u');

    const [time, setTime] = useState<number | string>('00')
    const [timeValue, setTimeValue] = useState<number>()
    const [type, setType] = useState('fridge')
    const [isError, setIsError] = useState(false)

    const calcUseTime = (power: number, type: string) => {

        //  大于 3800 直接报错
        if (power > 3800) {
            setIsError(true)
            return
        } else {
            setIsError(false)
        }
        // 1️⃣ 功率 1–5
        if (power >= 1 && power <= 5) {
            return 525;
        }
        // 2️⃣ 功率 3000–3800
        if (power >= 3000 && power <= 3800) {
            return 0.9;
        }
        const base = 3072 * 0.95 * 1;
        // 3️⃣ 空调 / 冰箱
        if (type === 'fridge') {
            return Number((base / (0.4 * power * 0.9)).toFixed(0));
        }
        // 4️⃣ 其他电器
        return Number((base / (power * 0.9)).toFixed(0));
    }
    const computationTime = () => {
        if (timeValue) {
            const time_ = calcUseTime(Number(timeValue), type)
            if (time_) setTime(time_)
        } else {
            setTime('00')
        }
    }
    useEffect(() => {
        if (time !== '00') {
            updateNumber(time)
            reset(); // 可选，避免叠加动画
            run();
        }
    }, [time]);
    const { curNumber, run, reset, updateNumber } = useCountUp({ number: time, time: 800 });
    return (
        <section className={`${css.section} D3U-Calculator GtmModuleData-section`} id="D3U-Calculator" data-section-id={'D3U-Calculator'} data-section-id2={t('Calculator_title')}>
            <div className="info">
                <p className="title">{t.rich('Calculator_title', {
                    t: (t: string) => <span>{t}</span>
                })}</p>
            </div>
            <ul className="items">
                <li className="item-left item">

                    <div className='item-title'>{t.rich('Calculator_tab1', {
                        t: (t: string) => <span>{t}</span>
                    })}</div>
                    <div className='item-icon-box'>
                        <div className={`item-icon-left item-icon ${type === 'fridge' ? 'active' : ''}`} onClick={() => {
                            setType('fridge')
                        }}>

                            <div className="svg">
                                <EcoImg className='icon' pc='https://websiteoss.ecoflow.com/upload/image/1768793302243/air_condition.jpg'></EcoImg>
                                <EcoImg className='icon' pc='https://websiteoss.ecoflow.com/upload/image/1768793302519/car_frige.png'></EcoImg>
                            </div>
                            {t('Calculator_icon1')}</div>
                        <div className={`item-icon-right item-icon ${type === 'else' ? 'active' : ''}`} onClick={() => {
                            setType('else')
                        }}>
                            <div className="svg">
                                <EcoImg className='icon' pc='https://websiteoss.ecoflow.com/upload/image/1768793325670/microwave.jpg'></EcoImg>
                                <EcoImg className='icon' pc='https://websiteoss.ecoflow.com/upload/image/1768793303144/laptop.jpg'></EcoImg>
                                <EcoImg className='icon' pc='https://websiteoss.ecoflow.com/upload/image/1768793302980/light.jpg'></EcoImg>
                            </div>
                            {t('Calculator_icon2')}
                        </div>
                    </div>
                    <div className='img'>
                        <EcoImg pc={'https://websiteoss.ecoflow.com/upload/image/1768528231127/Group%201612707933.png'} h5={'https://websiteoss.ecoflow.com/upload/image/1768528231127/Group%201612707933.png'} />
                    </div>
                </li>
                <li className='item-right item'>
                    <div className='item-title'> <div className='item-title'>{t.rich('Calculator_tab2', {
                        t: (t: string) => <span>{t}</span>
                    })}</div></div>
                    <div className='Calculator-box'>
                        <div className='time-box'>
                            <div className='time'> {(curNumber === '0' ? '00' : curNumber).split('').map((i, idx) => (
                                <div key={idx}>{i}</div>
                            ))}</div>
                            <div className='time-text'>
                                <p>{t('Calculator_time_1')}</p>
                            </div>
                        </div>
                        <div className='input-box' >
                            <div className={`input ${timeValue ? 'textColor' : ''}`} >
                                <input
                                    type="text"
                                    inputMode="numeric"
                                    value={timeValue}
                                    className="numberInput"
                                    onChange={(e) => {
                                        // 只允许整数
                                        const value = e.target.value.replace(/\D/g, '');
                                        setTimeValue(value ? Number(value) : undefined);

                                    }}
                                />
                                <span>{t('Calculator_time_2')}</span>
                            </div>
                            <div className='btn' onClick={computationTime} style={{
                                opacity: timeValue ? 1 : 0.5,
                                pointerEvents: timeValue ? 'auto' : 'none',
                            }}>
                                {t('Calculator_btn')}
                            </div>

                        </div>
                        {isError && <div className="error"> {t('Calculator_error')}</div>}
                    </div>
                    <p className='tips' > {t('Calculator_tips')}</p>
                </li>

            </ul>
            <p className='bottom'>
                {t('Calculator_footer')}
            </p>

        </section>
    );
};

export default D;
